import React, { FC } from 'react';
import { Image } from 'vitl-component-library';
import AddToBasket from '../add-to-basket';
import { Link } from 'gatsby';
import styles from './products-list-item.module.scss';
import useGetProductPlansData from '@src/features/shop/hooks/useGetProductPlansData';

interface IProductsListItemProps {
  product: any;
  isActive?: boolean;
  itemsPerRow?: number;
  isBundle?: boolean;
}

const ProductsListItem: FC<IProductsListItemProps> = ({
  product,
  isActive,
  itemsPerRow,
  isBundle,
}) => {
  const { dataPlans } = useGetProductPlansData(product.id);
  return (
    <div
      className={isActive ? styles[`productActive${itemsPerRow}`] : styles[`product${itemsPerRow}`]}
      id={product.id}
    >
      {isBundle && product.label_text && (
        <div
          className={styles.labelBox}
          style={{
            backgroundColor: product.label_background_color,
            color: product.label_text_color,
          }}
        >
          {product.label_text}
        </div>
      )}

      {!isBundle && (
      <Link to={`/product/${product.id}`} className={styles.link}>
        <Image filename={product.image_filename_disk} width={376} alt={product.title} />
      </Link>
      )}
      {isBundle && (
        <Image filename={product.image_filename_disk} width={376} alt={product.title} />
      )}

      <div className={styles.productBody}>
        {!isBundle && (
        <Link to={`/product/${product.id}`} className={styles.titleLink}>
          <h4>{product.title}</h4>
        </Link>
        )}
        {isBundle && (
          <h4>{product.title}</h4>
        )}

        <p className={styles.subheading}>
          <strong>{product.subtitle}</strong>
        </p>
        <p>{product.description}</p>
        
        <div className={styles.buySection}>
          <AddToBasket plans={dataPlans.product_plans} showPlanLabel={false} />
        </div>

        {!isBundle && (
          <Link to={`/product/${product.id}`} className={styles.link}>
            Learn more
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProductsListItem;
